<template>
  <div>
    <ticket-package></ticket-package>
    <el-row class="margintop20" type="flex" justify="center">
      <el-button @click="handleClick">{{ $t('button.cancel') }}</el-button>
      <el-button type="primary" @click="handleClick">{{ $t('button.confirm') }}</el-button>
    </el-row>
  </div>
</template>

<script>
import ticketPackage from '@/views/zooTicketsManager/ticketPackage/list/index.vue'

export default {
  components: {
    ticketPackage
  },
  methods: {
    handleClick () {
      this.$router.push({
        name: 'zooTicketsList'
      })
    }
  }
}
</script>

<style>

</style>
